import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { EventBus } from '../../services/eventbus.js';
import EditMixin from '../../components/core/dtwin/editMixin';
export default {
  name: 'ViewPublicTiles',
  mixins: [EditMixin],
  data: function data() {
    return {
      apiKeyError: false,
      apiKey: null,
      twinId: null,
      twinDataStates: [],
      updatedStates: [],
      footerData: {
        de: {},
        en: {}
      }
    };
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;

      var isShared;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.apiKey = this.$route.params.key;
              this.twinId = this.$route.params.id;
              ApiService.instance.interceptors.request.use(function (config) {
                config.headers['X-API-Key'] = _this.apiKey;
                return config;
              });
              _context.prev = 3;
              _context.next = 6;
              return this.$store.dispatch('authentication/verify', this.apiKey);

            case 6:
              _context.next = 8;
              return ApiService.digitalTwinIsShared(this, this.twinId).then(function (res) {
                return res.isShared;
              }).catch(function (error) {
                console.error(error);
              });

            case 8:
              isShared = _context.sent;

              if (isShared) {
                _context.next = 11;
                break;
              }

              throw new Error('TWIN_SHARING_NOT_ENABLED');

            case 11:
              if (this.$store.state.app.permissions) {
                _context.next = 14;
                break;
              }

              _context.next = 14;
              return this.$store.dispatch('app/loadPermissions');

            case 14:
              EventBus.$emit('refresh-branding');
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](3);
              this.apiKeyError = true;

            case 20:
              if (!this.apiKeyError) {
                ApiService.digitalTwinFetchStates(null, this.twinId).then(function (result) {
                  _this.twinDataStates = result.map(function (state) {
                    return Object.assign({}, state, {
                      title: state.properties.title,
                      unit: state.properties.unit
                    });
                  });
                }).catch(function (error) {
                  _this.apiKeyError = true;
                  console.error(error);
                });
              } // Get Footer Data for Datenschutzhinweis and Impress


              this.footerData = this.$store.state.app.footer;

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[3, 17]]);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }()
};